"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.bradford.description': 'Narratore britannico, espressivo e coinvolgente.',
};
